(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-panel-tipsen/assets/javascripts/draw-panel-tipsen.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-panel-tipsen/assets/javascripts/draw-panel-tipsen.js');
"use strict";

const {
  useSelector
} = ReactRedux;
const {
  ReactIcon
} = svs.ui;
const {
  WeekNr: weekNr
} = svs.utils.date;
const {
  Currency: currency
} = svs.utils.format;
const {
  Choose,
  When,
  Otherwise,
  If
} = svs.components.lbUtils.reactConditionals;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  useMemoizedSelector
} = svs.components.lbUtils.hooks;
const {
  getProductCompetitionId
} = svs.components.lbUtils.brandMapping.fn;
const {
  selectIsDrawIncludedInCompetitionWithId,
  selectDrawCountForDrawNumber
} = svs.components.marketplaceCompetition.services.selectors.competitionSelectors;
const {
  getGameIconByType
} = svs.components.tipsen.drawPanelTipsen.utils;
const {
  SportEventsWrapper,
  HotIcon
} = svs.components.tipsen.drawPanelTipsen;
const {
  useDefinition
} = svs.components.tipsen.engine.utils;
const {
  DrawPanel
} = svs.components.tipsen.drawSelectorComponents;
const {
  makeSelectLeaguesAccumulatedFromDraw
} = svs.components.tipsen.selectors;
const {
  selectJackpotById,
  selectGuaranteedJackpotById,
  selectExtraMoneyById,
  selectRolloverInById
} = svs.components.sport.drawsRedux.selectors;
const {
  CurrencyCounter
} = svs.components.tipsen.currencyCounter;
const CompetitionPanel = _ref => {
  let {
    regCloseTime,
    competition,
    currentCompetitionDraw
  } = _ref;
  return React.createElement("div", {
    className: "draw-panel-title-competition f-medium"
  }, React.createElement("span", {
    className: "draw-panel-title-primary f-800"
  }, "Vecka ".concat(weekNr(regCloseTime))), React.createElement("span", {
    className: "draw-panel-title-secondary f-600"
  }, "".concat(competition === null || competition === void 0 ? void 0 : competition.compDesc, ", Omg\xE5ng ").concat(currentCompetitionDraw)));
};
const DrawPanelTipsen = _ref2 => {
  var _useSelector, _useSelector2, _jackpot$jackpotAmoun;
  let {
    draw,
    isOpened,
    isLargeDevice,
    isExpanded
  } = _ref2;
  const definition = useDefinition();
  const {
    useCompetition
  } = svs.components.tipsen.competition.competitionFactoryInstance.getCompetitionFactoryInstance().getCompetitionHooksForCms();
  const {
    currentNetSale = 0,
    regCloseTime,
    sportType,
    productId,
    drawNumber
  } = draw || {};
  const competitionId = getProductCompetitionId(productId);
  const currentCompetitionDraw = (_useSelector = useSelector(state => selectDrawCountForDrawNumber(state, competitionId, drawNumber))) !== null && _useSelector !== void 0 ? _useSelector : undefined;
  const competition = useCompetition();
  const isDrawIncludedInCompetitionWithId = (_useSelector2 = useSelector(state => selectIsDrawIncludedInCompetitionWithId(state, productId, drawNumber, competitionId))) !== null && _useSelector2 !== void 0 ? _useSelector2 : false;
  const isDrawIncludedInCompetition = isDrawIncludedInCompetitionWithId && Boolean(competition);
  const jackpot = useSelector(state => selectJackpotById(state, productId, drawNumber));
  const guaranteedJackpot = useSelector(state => selectGuaranteedJackpotById(state, productId, drawNumber));
  const jackpotAmount = (_jackpot$jackpotAmoun = jackpot === null || jackpot === void 0 ? void 0 : jackpot.jackpotAmount) !== null && _jackpot$jackpotAmoun !== void 0 ? _jackpot$jackpotAmoun : '';
  const rullPott = useSelector(state => selectRolloverInById(state, productId, drawNumber));
  const extraMoney = useSelector(state => selectExtraMoneyById(state, productId, drawNumber));
  const guaranteedJackpotAmount = definition.hasGuaranteedJackpot && guaranteedJackpot !== null && guaranteedJackpot !== void 0 && guaranteedJackpot.jackpotAmount ? guaranteedJackpot.jackpotAmount : '';
  const productDrawId = "".concat(productId, "_").concat(drawNumber);
  const selectLeaguesCountFromDraw = useMemoizedSelector(makeSelectLeaguesAccumulatedFromDraw, productDrawId);
  const leaguesAccumulatedInOrder = useSelector(selectLeaguesCountFromDraw);
  if (!draw) {
    return null;
  }
  return React.createElement(React.Fragment, null, React.createElement(DrawPanel, null, React.createElement("div", {
    className: "draw-panel-primary-header"
  }, React.createElement(ReactIcon, {
    className: "".concat(isDrawIncludedInCompetition ? 'game-type-icon-competiton' : '', " game-type-icon"),
    color: "icon-inverted",
    icon: isDrawIncludedInCompetition ? 'trophy-tips-sm' : getGameIconByType(sportType),
    size: "300"
  }), React.createElement(Choose, null, React.createElement(When, {
    condition: isDrawIncludedInCompetition
  }, React.createElement(CompetitionPanel, {
    competition: competition,
    currentCompetitionDraw: currentCompetitionDraw,
    regCloseTime: regCloseTime
  })), React.createElement(Otherwise, null, React.createElement("div", {
    className: "draw-panel-title f-800 f-medium"
  }, "Vecka ".concat(weekNr(regCloseTime)))))), React.createElement("ul", {
    className: "summary"
  }, React.createElement(Choose, null, React.createElement(When, {
    condition: jackpotAmount.length > 0
  }, React.createElement("li", {
    className: "summary-item",
    "data-testid": "summary-item-jackpot"
  }, "Jackpot ".concat(currency(jackpotAmount), " kr"), React.createElement(HotIcon, null))), React.createElement(When, {
    condition: Boolean(extraMoney)
  }, React.createElement("li", {
    className: "summary-item"
  }, "Extrapengar ".concat(currency(extraMoney), " kr"), React.createElement(HotIcon, null))), React.createElement(When, {
    condition: Boolean(rullPott)
  }, React.createElement("li", {
    className: "summary-item"
  }, "Rullpott ".concat(currency(rullPott), " kr"), React.createElement(HotIcon, null))), React.createElement(When, {
    condition: guaranteedJackpotAmount.length > 0
  }, React.createElement("li", {
    className: "summary-item"
  }, "Ensam vinnare \xE4r garanterad ".concat(currency(guaranteedJackpotAmount), " kr")))), React.createElement(Choose, null, React.createElement(When, {
    condition: !isOpened
  }, React.createElement("li", {
    className: "summary-item"
  }, "Spelomg\xE5ng ej startad")), React.createElement(When, {
    condition: isOpened
  }, React.createElement("li", {
    className: "summary-item",
    "data-testid": "summary-item-netsale"
  }, 'Omsättning ', React.createElement(CurrencyCounter, {
    amount: currentNetSale
  }), ' kr'))), React.createElement("li", {
    className: "summary-item",
    "data-testid": "summary-item-reg-close-time"
  }, "Spelstopp ".concat(formatDate(regCloseTime, true, true, false))), React.createElement(If, {
    condition: isLargeDevice && leaguesAccumulatedInOrder.length > 0
  }, React.createElement("li", {
    className: "summary-item summary-item-transitional".concat(isExpanded ? '' : ' hidden')
  }, React.createElement("span", {
    className: "leagues-summary"
  }, React.createElement("span", {
    className: "first-occurred-league",
    "data-testid": "summary-item-first-occurred-league"
  }, leaguesAccumulatedInOrder[0].name || leaguesAccumulatedInOrder[0].uniqueLeagueName), leaguesAccumulatedInOrder.length > 1 && React.createElement("span", {
    className: "additional-leagues-count",
    "data-testid": "summary-item-additional-leagues-count"
  }, "+".concat(leaguesAccumulatedInOrder.length - 1)))))), React.createElement(SportEventsWrapper, {
    limit: 1,
    productDrawId: productDrawId
  })), React.createElement(If, {
    condition: isLargeDevice
  }, React.createElement(DrawPanel, {
    isSecondary: true
  }, React.createElement(SportEventsWrapper, {
    limit: 3,
    productDrawId: productDrawId
  }))));
};
setGlobal('svs.components.tipsen.drawPanelTipsen.DrawPanelTipsen', DrawPanelTipsen);

 })(window);